<template>
  <div class="bottom-menu">
    <van-tabbar v-model="active" >
      <van-tabbar-item v-for="(menu,index) in menus"  icon="" :key="index" :to="menu.to">
        <van-badge :content="menu.badge"><div class="cnt-badge-text">{{menu.title}}</div></van-badge>
      </van-tabbar-item>
    </van-tabbar>
  </div>
  <div class="floating-ball" v-if="showFloatingBall">
    <van-icon name="close" class="floating-ball-close" @click="showFloatingBall=false" />
    <a href="https://v.wjx.cn/vm/Otv9FVi.aspx" target="_blank">
      <van-button size="small" type="default" icon="add">新增平台</van-button>
    </a>
  </div>
</template>
<style lang="less">
@import '@/app.less';
.bottom-menu{
  --van-badge-background: @color2;
}
.cnt-badge-text{
  height:2rem;
  line-height:2rem;
}

.floating-ball {
  position: fixed;
  right: 1rem;
  bottom: 20%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1000;
  transition: all 0.3s ease;
  .floating-ball-close{
    font-size: 1rem;
    right: -1rem;
    top: -1rem;
    position: absolute;
  }
}

.floating-ball:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}
</style>
<script>
import store from "@/store";
import { format } from 'date-fns';
import {onMounted, ref, watch} from "vue";
import ClipbordComponent from "@/components/Clipbord.vue";
import app from "@/App.vue";
import {useRouter} from "vue-router";

const familyMenu = [
  {
    title: "家族配置",
    to: "/family-config",
    show:true
  },
  {
    title: "会员充值",
    to: "/pay",
  },
  {
    title: "下载",
    to: "/",
    badge:"新"
  }];

const doumiMenu = [
  {
    title: "抖小蜜配置",
    to: "/doumi-config",
    show:true
  },
  {
    title: "会员充值",
    to: "/pay",
  },
  {
    title: "下载",
    to: "/",
    badge:"新"
  }];

const dacalMenu = [
  {
    title: "数据",
    to: "/data-desc",
  },
  {
    title: "会员充值",
    to: "/pay"
  },
  {
    title: "下载",
    to: "/",
    badge:"新"
  },
];

const menuMap = {
  "FamilyMember": familyMenu,
  "DataMember": dacalMenu,
  "DoumiMember": doumiMenu,
};

export default {
  name: "BottomMenu",
  computed: {
    app() {
      return app
    }
  },
    components: {},
    setup(){
       const userStore = store.userStore();
       const bizType = userStore.getBizType();

       const menus = ref(menuMap[bizType]);
       const active = ref(0);
       const showFloatingBall = ref(bizType === "DataMember");
       const state = ref({
            showFloatingBall,
            user: userStore.user,
            active,
            menus
       });

      const router = useRouter();
      const updateActive = () => {
        const path = router.currentRoute.value.path;
        console.log("updateActive:",menus.value)
        menus.value.forEach((menu, index) => {
          if(menu.to === path){
            active.value = index;
          }
        });
      }

      onMounted(async () => {
        watch(userStore.user, async (value) => {
          if(value.familyUser){
            menus.value = familyMenu;
          }
        });

        watch(router.currentRoute,(value) => {
          updateActive();
        });

        watch(menus,(value) => {
          updateActive();
        });
      });

      return state.value;
    }
}
</script>
